import React, { useState, useEffect, useRef } from 'react';

export default function LineaInput({ value, onChange, placeholder, style }) {
  const [query, setQuery] = useState(value || '');
  const [sugerencias, setSugerencias] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const [loading, setLoading] = useState(false);
  const timeout = useRef(null);
  const ref = useRef(null);

  useEffect(() => { setQuery(value || ''); }, [value]);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const buscar = (q) => {
    setQuery(q);
    onChange(q);
    clearTimeout(timeout.current);
    if (q.length < 2) { setSugerencias([]); setAbierto(false); return; }
    setLoading(true);
    timeout.current = setTimeout(async () => {
      try {
        const BASE = "https://services7.arcgis.com/XTupIrLX53AjaJqO/arcgis/rest/services/Red_Ferroviaria_de_Inter%C3%A9s_General___Adif__RFIG_CM_vista_2/FeatureServer/43/query";
        const filtro = `COD_LINEA LIKE '%${q}%'`;
        const url = `${BASE}?f=json&where=${encodeURIComponent(filtro)}&outFields=COD_LINEA&returnDistinctValues=true&resultRecordCount=10`;
        const r = await fetch(url);
        const data = await r.json();
        const lineas = [...new Set((data.features || []).map(f => f.attributes.COD_LINEA).filter(Boolean))].sort();
        setSugerencias(lineas);
        setAbierto(true);
      } catch {}
      setLoading(false);
    }, 300);
  };

  const seleccionar = (linea) => {
    setQuery(linea);
    onChange(linea);
    setSugerencias([]);
    setAbierto(false);
  };

  return (
    <div ref={ref} style={{ position: 'relative', ...style }}>
      <input value={query} onChange={e => buscar(e.target.value)}
        onFocus={() => query.length >= 2 && sugerencias.length > 0 && setAbierto(true)}
        placeholder={placeholder || 'Buscar línea...'}
        style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
      {loading && <div style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', fontSize: 12, color: '#aaa' }}>...</div>}
      {abierto && sugerencias.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ddd', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 1000, maxHeight: 260, overflowY: 'auto', marginTop: 2 }}>
          {sugerencias.map((linea, i) => (
            <div key={i} onMouseDown={() => seleccionar(linea)}
              style={{ padding: '9px 14px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', fontSize: 12 }}
              onMouseEnter={e => e.currentTarget.style.background = '#f8f8f6'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
              🛤️ {linea}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
